//context
import { useContext, useEffect, useState } from 'react';
import { ActivityFeedContext } from '@/context/ActivityFeedContext';

//helpers
import { formatActivityTime, getAppDetails, getAcknowledgementType, getExtendedContentDetails, getParentListDetails, getUniqueActivityKey, getUserDetails, getContentDetails, formatLongDateGroup } from  '@/helpers/ActivityFeed';

//interfaces
import { IActivityProps, UserActivity } from  '@/interfaces/activityFeed';
import { IMeta } from  '@/interfaces/activityFeedNotifications';

//components
import AcknowledgementPost from '../notifications/AcknowledgementPost/AcknowledgementPost';
import RecognitionPost from '../notifications/Recognition/RecognitionPost';
import FormResponse from '../notifications/FormResponse/FormResponse';
import PasskeysReset from '../notifications/PasskeysReset/PasskeysReset';



const UserGeneratedActivity = ({zIndexNum, isPopOut, activity: {author, contentItem, parentLists, isRemovedFromParent, parentList, createdAt, activityType, workspace, meta, acknowledgement, recognition, accountRecoveryRequest}} : IActivityProps) => { 
    const { downloadAcknowledgementReport, downloadFormResponseCSV, getOpenOnWebLink, userProfileImage, likeContent, postCommentOnContent, onArchiveContentClick, isMultipleAppOrganisation, getNotification } = useContext(ActivityFeedContext);
    const id = getUniqueActivityKey(activityType, contentItem?.id ?? 0, createdAt, author?.id)
    const notificationDetails = getNotification(id) ?? undefined
    const [contentMeta, setContentMeta] = useState<IMeta>(meta);

    useEffect(() => {
        setContentMeta(meta);
    }, [meta]);
        
    function handleLikeClick(){
        setContentMeta((prev: IMeta) => {
            const updated = {
                ...prev,
                likeCount: prev.hasLiked ? prev.likeCount - 1 : prev.likeCount + 1,
                hasLiked: !prev.hasLiked
            };

            // Persist change
            likeContent(id, workspace.id, contentItem.id, prev.hasLiked);

            return updated;
        });
    }

    function handleCommentClick(comment: string) {
        postCommentOnContent(id, contentItem.id, comment, workspace.id)
    }

    function handleArchive(){
        onArchiveContentClick( id, parentList?.id, contentItem.id)
    }

    if (activityType === UserActivity.acknowledgementResponse) {
        return (
            <AcknowledgementPost
                zIndexNum={zIndexNum}
                key={id}
                activityId={id}
                isPopOut={isPopOut}
                timeStamp={formatActivityTime(createdAt)}
                dateStamp={formatLongDateGroup(createdAt)}
                user={getUserDetails(author)}
                content={getContentDetails(contentItem, parentLists[0], workspace, parentLists?.length > 1)}
                parentList={getParentListDetails(parentLists[0], workspace)}
                appDetails={getAppDetails(workspace, isMultipleAppOrganisation)}
                acknowledgementType={getAcknowledgementType(acknowledgement.acknowledgementType)}
                getOpenOnWebLink={() => getOpenOnWebLink(contentItem.id)}
                onDownloadReportClick={() => downloadAcknowledgementReport(workspace.appGuid, contentItem.id)}
            />
        )
    } else if (activityType === UserActivity.recognition) { 
        return  (
            <RecognitionPost
                zIndexNum={zIndexNum}
                key={id}
                activityId={id}
                isPopOut={isPopOut}
                timeStamp={formatActivityTime(createdAt)}
                dateStamp={formatLongDateGroup(createdAt)}
                user={getUserDetails(author)}
                content={getExtendedContentDetails(contentItem, parentList, workspace, contentMeta, parentLists?.length > 1)}
                parentList={getParentListDetails(parentList, workspace)}
                meta={contentMeta}
                recognition={recognition}
                appDetails={getAppDetails(workspace, isMultipleAppOrganisation)}
                editorProfileImage={userProfileImage}
                onLikeClick={handleLikeClick}
                onPostCommentClick={handleCommentClick}
                getWebLink={() => getOpenOnWebLink(contentItem.id)}
                onArchiveContentClick={handleArchive}
                notificationDetails={notificationDetails}
                isRemovedFromParentList={isRemovedFromParent} 
            />
        )
    } else if (activityType === UserActivity.formResponse) { 
        return  (
            <FormResponse
                zIndexNum={zIndexNum}
                key={id}
                activityId={id}
                isPopOut={isPopOut}
                timeStamp={formatActivityTime(createdAt)}
                dateStamp={formatLongDateGroup(createdAt)}
                user={getUserDetails(author)}
                content={getContentDetails(contentItem, parentLists[0], workspace, parentLists?.length > 1)}
                parentList={getParentListDetails(parentLists[0], workspace)}
                appDetails={getAppDetails(workspace, isMultipleAppOrganisation)}
                onDownloadCSVClick={() => downloadFormResponseCSV(contentItem.id, contentItem.formId)}
            />
        )
    } else if (activityType === UserActivity.accountRecoveryRequest) { 
        return  (
            <PasskeysReset
                key={id}
                zIndexNum={zIndexNum}
                activityId={id}
                isPopOut={isPopOut}
                timeStamp={formatActivityTime(createdAt)}
                dateStamp={formatLongDateGroup(createdAt)}
                user={getUserDetails(author)}
                client={meta.client}
                userPageLink={`${window.location.origin}/admin/OrganizationUser/EditAdminDetails/${author.id}`}
                message={accountRecoveryRequest?.requestMessage ?? ""}
             />
        )
    }
                    
    return null; 
}
export default UserGeneratedActivity